var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDanger(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 16,
    viewBox: "0 0 18 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.06299 12.2617C8.06299 12.5104 8.16177 12.7488 8.33758 12.9246C8.5134 13.1004 8.75185 13.1992 9.00049 13.1992C9.24914 13.1992 9.48759 13.1004 9.66341 12.9246C9.83922 12.7488 9.93799 12.5104 9.93799 12.2617C9.93799 12.0131 9.83922 11.7746 9.66341 11.5988C9.48759 11.423 9.24914 11.3242 9.00049 11.3242C8.75185 11.3242 8.5134 11.423 8.33758 11.5988C8.16177 11.7746 8.06299 12.0131 8.06299 12.2617ZM8.37549 6.32422V9.91797C8.37549 10.0039 8.44581 10.0742 8.53174 10.0742H9.46924C9.55518 10.0742 9.62549 10.0039 9.62549 9.91797V6.32422C9.62549 6.23828 9.55518 6.16797 9.46924 6.16797H8.53174C8.44581 6.16797 8.37549 6.23828 8.37549 6.32422ZM17.6665 14.918L9.54151 0.855469C9.42042 0.646484 9.21143 0.542969 9.00049 0.542969C8.78956 0.542969 8.57862 0.646484 8.45948 0.855469L0.334479 14.918C0.0942449 15.3359 0.395026 15.8555 0.875495 15.8555H17.1255C17.606 15.8555 17.9067 15.3359 17.6665 14.918ZM2.36378 14.373L9.00049 2.88477L15.6372 14.373H2.36378Z",
    fill: "#FF7228"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDanger);
export default __webpack_public_path__ + "static/media/danger.c61978abb460c8b70451bcd2d5c3e3d8.svg";
export { ForwardRef as ReactComponent };